exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer {\n  padding: 30px 0;\n  text-align: center;\n  font-size: 14px;\n  color: #686868;\n}\n@media screen and (max-width: 569px) {\n  .footer {\n    padding: 20px  0px !important;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A"}}!./src/component/footer/index.less
// module id = 262
// module chunks = 0